<template>
  <section class="page-root">
    <div
      class="page-wrap"
      :class="[wrapClass ? wrapClass : '', isFullPage ? 'page-full' : '']"
    >
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "PageWrap",
  props: {
    wrapClass: { type: String, default: "" },
    isFullPage: { type: Boolean, default: true },
  },
  data() {
    return {};
  },
  components: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.page-root {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/images/auth-page-bg.png") no-repeat fixed center;
  background-size: 100% 100%;
}
.page-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  &.page-full {
    height: 100%;
    width: 100%;
    margin: 0 auto;
  }
}
</style>
